<container *ngIf="exibirCarregando">
  <app-carregando-indeterminado></app-carregando-indeterminado>
</container>

<container *ngIf="msgDeErro">
  <label class="texto-cinza">{{ msgDeErro }}</label>
</container>

<container *ngIf="true">
  <container *ngIf="tipoDeMedia === 'IMAGEM'">
    <img 
      #imagem
      id="imagem">
    <!-- <div class="container-arquivo-nome">
      <label class="texto-cinza">{{ urlArquivo }}</label>
    </div> -->
  </container>
  
  <container *ngIf="tipoDeMedia === 'VIDEO'">
    <video 
      #video
      width="320" 
      height="240" 
      controls
      poster>
      <source 
        #videoSource
        src="" 
        type="" />
      <!--Suportado em IE9, Chrome 6 e Safari 5 -->
      O seu navegador não suporta este reprodutor de vídeo.
    </video>
  </container>
  
  <container *ngIf="tipoDeMedia === 'ARQUIVO'">
    <a
      #linkArquivo 
      href="" 
      download>
      {{ urlArquivo }}
    </a>
  </container>
</container>